import React from "react";
import * as routes from "./constants/routes";
import { Route /*  Redirect,  Switch  */ } from "react-router-dom";
import Layout from "./hoc/Layout";
import "font-awesome/css/font-awesome.min.css";

import Dashboard from "./containers/Dashboard/Dashboard";
import DashboardProto from "./containers/DashboardProto/DashboardProto";
// Audiofoco
import RegisteredCompanies from "./containers/Audiofoco/RegisteredCompanies/RegisteredCompanies";
import AddCompany from "./containers/Audiofoco/AddCompany/AddCompany";
import AudiofocoUsers from "./containers/Audiofoco/AudiofocoUsers/AudiofocoUsers";
// Afinando
import DadosUsuarios from "./containers/Afinando/UserData/DadosUsuarios";
import UserDataLinked from "./containers/Afinando/UserDataLinked/UserDataLinked";
import UserDataDetails from "./containers/Afinando/UserDataDetails/UserDataDetails";
import ExcluirUsuario from "./containers/Afinando/DeleteUser/DeleteUser";
import CancelPlan from "./containers/Afinando/CancelPlan/CancelPlan";
// Afinando - Recompensas
import Recompensas from "./containers/Afinando/Recompensas/Recompensas";
import AddRewards from "./containers/Afinando/Recompensas/AddRewards/AddRewards";
import EditRewards from "./containers/Afinando/Recompensas/EditReward/EditReward";
// Afinando - Atividade
import Activities from "./containers/Afinando/Activities/Activities";
import AddActivities from "./containers/Afinando/Activities/AddActivities/AddActivities";
import EditActivities from "./containers/Afinando/Activities/EditActivities/EditActivities";
import SyncActivities from "./containers/Afinando/Activities/SyncActivities/SyncActivities";
// Afinando - Banner
import Banners from "./containers/Afinando/Banners/Banners"
import AddBanner from "./containers/Afinando/Banners/AddBanner/AddBanner";
import EditBanner from "./containers/Afinando/Banners/EditBanner/EditBanner";
// Afinando Eventos
import Events from "./containers/Afinando/Events/Events";
import EditEvent from "./containers/Afinando/Events/EditEvent/EditEvent";
// Audbility
import AudbilityUsers from "./containers/Audbility/AudbilityUsers/AudbilityUsers"
import AudbilityValidateCrfa from "./containers/Audbility/AudbilityValidateCrfa/AudbilityValidateCrfa"
import AudbilityUserDetails from "./containers/Audbility/AudbilityUserDetails/AudbilityUserDetails"

import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports-prod";

Amplify.configure(awsExports);
function App() {
  return (
    <Layout>
      <Route exact path="/admin" name="dashboard" component={Dashboard} />
      <Route
        exact
        path="/admin/dashboard-proto"
        name="dashboard-proto"
        component={DashboardProto}
      />
      <Route
        exact
        path="/admin/planos-do-usuario"
        name="dados-usuarios"
        component={DadosUsuarios}
      />
      <Route
        exact
        path="/admin/empresas-cadastradas"
        name="dados-usuarios"
        component={RegisteredCompanies}
      />
      <Route
        exact
        path={routes.R_ADD_COMPANIES}
        name="dados-usuarios"
        component={AddCompany}
      />
      <Route
        exact
        path="/admin/audiofoco-usuarios"
        name="dados-usuarios"
        component={AudiofocoUsers}
      />
      <Route
        exact
        path="/admin/planos-do-usuario/user/:parent_sub"
        name="dados-usuarios"
        component={UserDataLinked}
      />
      <Route
        exact
        path="/admin/planos-do-usuario/details/:email"
        name="dados-usuarios"
        component={UserDataDetails}
      />
      <Route
        exact
        path="/admin/cancelar-plano"
        name="dados-usuarios"
        component={CancelPlan}
      />
      <Route
        exact
        path="/admin/excluir-usuario"
        name="dados-usuarios"
        component={ExcluirUsuario}
      />
      
      {/* RECOMPENSAS */}
      <Route
        exact
        path="/admin/recompensas"
        name="recompensas"
        component={Recompensas}
      />
      <Route
        exact
        path={routes.R_ADD_REWARDS}
        name="recompensas"
        component={AddRewards}
      />
      <Route
        exact
        path="/admin/editar_recompensa/:reward_id"
        name="recompensas"
        component={EditRewards}
      />

      {/* ATIVIDADES */}
      <Route
        exact
        path="/admin/atividades"
        name="atividades"
        component={Activities}
      />
      <Route
        exact
        path="/admin/adicionar_atividades"
        name="atividades"
        component={AddActivities}
      />
      <Route
        exact
        path="/admin/editar_atividades/:activities_id"
        name="atividades"
        component={EditActivities}
      />
      <Route
        exact
        path="/admin/sincronizar_atividades"
        name="atividades"
        component={SyncActivities}
      />

      {/* BANNERS */}
      <Route
        exact
        path="/admin/banners"
        name="banners"
        component={Banners}
      />
      <Route
        exact
        path="/admin/adicionar_banner"
        name="banners"
        component={AddBanner}
      />
      <Route
        exact
        path="/admin/editar_banner/:banner_id"
        name="banners"
        component={EditBanner}
      />
      
      {/* EVENTOS */}
      <Route
        exact
        path={routes.R_EVENTS}
        name="eventos"
        component={Events}
      />
      <Route
        exact
        path={routes.R_ADD_EVENTS}
        name="eventos"
        component={EditEvent}
      />
      <Route
        exact
        path="/admin/editar_evento/:event_id"
        name="eventos"
        component={EditEvent}
      />

      {/* AUDBILITY */}
      <Route
        exact
        path="/admin/audbility-usuarios"
        name="audbility"
        component={AudbilityUsers}
      />
      <Route
        exact
        path="/admin/audbility-usuarios/details/:sub"
        name="audbility"
        component={AudbilityUserDetails}
      />
      <Route
        exact
        path="/admin/audbility-validar-crfa"
        name="audbility"
        component={AudbilityValidateCrfa}
      />
    </Layout>
  );
}

export default App;
